// Shared config for the Property Management modules (Directory + Financials).

export const DIRECTORY_TYPES = [
  "Architect", "Builder", "Client", "Consultant", "Contact", "Engineer", "General Contractor",
  "Government / Agency", "Inspector", "Lender", "Realtor", "Subcontractor", "Vendor", "Other",
];

export const DIRECTORY_TRADES = [
  "Appliances", "Architect", "Cabinetry / Millwork", "Civil Engineer", "Concrete / Foundation",
  "Drywall", "Electrical", "Excavation / Grading", "Finance", "Flooring / Tile", "Framing",
  "General Contractor", "HVAC", "Insulation", "Interior Designer", "Landscape Architect",
  "Landscaping", "Masonry", "Materials Supplier", "MEP Engineer", "Painting", "Plumbing",
  "Pool / Spa", "Real Estate", "Roofing", "Solar", "Structural Engineer", "Surveyor",
  "Windows & Doors", "Other",
];

export const DIRECTORY_STATUSES = ["Active", "Preferred", "Inactive", "Do Not Use"];

// Financial document types (one entry = one line item of a given kind).
export const FIN_KINDS = [
  { value: "budget", label: "Budget Line", group: "budget" },
  { value: "estimate", label: "Estimate", group: "estimate" },
  { value: "contract", label: "Contract", group: "commitment" },
  { value: "purchase_order", label: "Purchase Order", group: "commitment" },
  { value: "change_order", label: "Change Order", group: "change" },
  { value: "expense", label: "Bill / Expense", group: "cost" },
  { value: "payment", label: "Payment / Draw", group: "payment" },
  { value: "allowance", label: "Allowance", group: "allowance" },
  { value: "contingency", label: "Contingency", group: "allowance" },
];

export const FIN_KIND_LABEL = FIN_KINDS.reduce((a, k) => { a[k.value] = k.label; return a; }, {});

// Tabs on the project drilldown — each groups one or more kinds.
export const FIN_TABS = [
  { key: "all", label: "All Items", kinds: FIN_KINDS.map((k) => k.value) },
  { key: "budget", label: "Budget", kinds: ["budget"] },
  { key: "estimate", label: "Estimates", kinds: ["estimate"] },
  { key: "commitment", label: "Commitments", kinds: ["contract", "purchase_order"] },
  { key: "cost", label: "Bills & Expenses", kinds: ["expense"] },
  { key: "change", label: "Change Orders", kinds: ["change_order"] },
  { key: "payment", label: "Payments / Draws", kinds: ["payment"] },
  { key: "allowance", label: "Allowances & Contingency", kinds: ["allowance", "contingency"] },
];

export const FIN_CATEGORIES = [
  "General Conditions", "Site Work / Excavation", "Foundation", "Framing", "Roofing",
  "Windows & Doors", "Exterior / Cladding", "Plumbing", "Electrical", "HVAC",
  "Insulation", "Drywall", "Flooring & Tile", "Painting", "Cabinetry / Trim",
  "Appliances", "Landscaping / Driveway", "Permits & Fees",
  "Architecture & Engineering", "Contingency", "Other",
];

export const FIN_STATUSES = ["Draft", "Pending", "Approved", "Committed", "Invoiced", "Paid", "Rejected", "Void"];

export const FIN_STATUS_COLORS = {
  Draft: "#94a3b8", Pending: "#f59e0b", Approved: "#3b82f6", Committed: "#8b5cf6",
  Invoiced: "#eab308", Paid: "#16a34a", Rejected: "#ef4444", Void: "#64748b",
};

export const DOC_CATEGORIES = [
  "Plans / Drawings", "Permits", "Contracts", "Invoices", "Inspections", "Photos", "Due Diligence", "Other",
];
